import React from "react";
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import * as style  from "../utilities/getStyle";
import * as tag from "../constants/customMetadataConstants";
import * as ddo from "../constants/customObjConstants";
import * as portalShared from "../shared/metadataConstantsAndUtilities"


export function saveMultiSelect(question, answerOption, props) {

    const {
        surveyEditMode,
        displayMode,
        answerQuestionOptions,
        answerQuestionTemplateOptions
    } = props;

    if (surveyEditMode === portalShared.EDITABLE_SURVEY) {
        // See if template or instance
        if (displayMode === portalShared.INSTANT_MODE) {
            answerQuestionOptions(question.id, answerOption.key, {selected: !answerOption.selected}, "multi-select", question);
        } else {
            let tempAnswer = {...answerOption};
            tempAnswer.selected = !answerOption.selected;
            answerQuestionTemplateOptions(question.id, answerOption.key, tempAnswer, "multi-select", question);
        }
    }
}


export function multiSelectQuestion() {
    const {question} = this.props;
    let customTemplateObj;

    if (tag.metadataExists(question, portalShared.CUSTOM_DDO_QUE_FORMAT)) {
        customTemplateObj = tag.metadataValueObj(question, portalShared.CUSTOM_DDO_QUE_FORMAT);

        if (customTemplateObj.version < 2) {
            let defaultCustomTemplateObj = portalShared.getCustomQuestionCheckboxObj();

            portalShared.matchObj(defaultCustomTemplateObj, customTemplateObj);
        }


    } else {
        customTemplateObj = portalShared.getCustomQuestionCheckboxObj(question.questionType);
    }

    let readonlyMode = (this.props.surveyEditMode === portalShared.READONLY_SURVEY);

    let answers = ddo.getAnswerOptions(question);

    let textObj;
    textObj = customTemplateObj?.text;

    let hoverColorText = customTemplateObj.hoverText.color;

    let CustomTypographyStyle = style.getCustomTextStyle(textObj, hoverColorText);

    //let outlinedCheckboxesMode = tag.metadataExists(question, portalShared.DISPLAY_CHECKBOXES_AS_OUTLINED);

    //let unselectedColorControl = customTemplateObj?.unselectedControl?.color ?? portalShared.COLOR_GRAY_HEX;
    // let unselectedColorText = customTemplateObj?.unselectedText?.color ?? undefined;

    //let hoverColorControl = customTemplateObj?.hoverControl?.color ?? portalShared.COLOR_DEFAULT_BLUE_HEX;

    //let selectedColorControl = customTemplateObj?.selectedControl?.color ?? portalShared.COLOR_DEFAULT_BLUE_HEX;
    // let selectedColorText = customTemplateObj?.selectedText?.color ?? undefined;


    let sideBySide = "row";

    // let controlColorObj = {
    //     color: portalShared.COLOR_GRAY_HEX,
    //     selectedColor: portalShared.COLOR_DEFAULT_BLUE_HEX,
    //     hoverColor: portalShared.COLOR_DEFAULT_BLUE_HEX,
    //     hoverSelectedColor: portalShared.COLOR_DEFAULT_BLUE_HEX
    // }
    //
    // let textColorObj = {
    //     color: portalShared.COLOR_GRAY_HEX,
    //     selectedColor: portalShared.COLOR_DEFAULT_BLUE_HEX,
    //     hoverColor: portalShared.COLOR_DEFAULT_BLUE_HEX,
    //     hoverSelectedColor: portalShared.COLOR_DEFAULT_BLUE_HEX
    // }

    //let customTemplateObj = null; // NULL if no custom question object

    // if (tag.metadataExistsObj(question, portalShared.CUSTOM_DDO_QUE_FORMAT)) {
    //     customTemplateObj = tag.metadataValueObj(question, portalShared.CUSTOM_DDO_QUE_FORMAT);
    // } else {
    //     customTemplateObj = portalShared.getCustomQuestionCheckboxObj(); // force push
    // }

    //if (customTemplateObj !== null) {

        let controlColorObj = {
            color: portalShared.getColor(customTemplateObj.unselectedControl),
            selectedColor: portalShared.getColor(customTemplateObj.selectedControl),
            hoverColor: portalShared.getColor(customTemplateObj.hoverControl),
            hoverSelectedColor: portalShared.getColor(customTemplateObj.hoverSelectedControl),
        };

        let textColorObj = {
            color: portalShared.getColor(customTemplateObj.unselectedText),
            selectedColor: portalShared.getColor(customTemplateObj.selectedText),
            hoverColor: portalShared.getColor(customTemplateObj.hoverText),
            hoverSelectedColor: portalShared.getColor(customTemplateObj.hoverSelectedText)
        }

        sideBySide = customTemplateObj.arrange;
    //}

    // const StyledCheckbox = styled(Checkbox)({
    //     // color: unselectedColorControl,
    //     // "&.Mui-checked": {
    //     //     color: selectedColorControl,
    //     // },
    //     // "&:hover": {
    //     //     color: hoverColorControl, // Define the hover color
    //     // },
    //     checked: {color: "red"},
    // });


    //let sideBySide = tag.metadataExists(question, portalShared.DISPLAY_SINGLE_SELECT_AS_SIDE_BY_SIDE_WRAP) || tag.metadataExists(question, portalShared.DISPLAY_SINGLE_SELECT_AS_SIDE_BY_SIDE);
    //
    //
    // if (questionCustomObj)) {
    //     let questionCustomObj = tag.metadataValueObj(question, portalShared.CUSTOM_DDO_QUE_FORMAT);
    //
    // }



    // NOTE: The migration to MUI v5 eliminated outlined checkboxes
    // if (outlinedCheckboxesMode) {
    //
    //     let outlinedOverrides = style.getOutlinedOverrides(question, textObj);
    //
    //     let StyledFormControlLabel = null;
    //
    //     return (
    //         <FormGroup style={{display: "flex", flexDirection: sideBySide ? "row" : "column", paddingLeft: "10px"}}>
    //             {answers.map(answer => {
    //
    //                 StyledFormControlLabel = style.getStyledFormControlLabel(outlinedOverrides, answer.selected, readonlyMode);
    //
    //                 return (
    //                     <StyledFormControlLabel
    //                         key={answer.id}
    //                         control={
    //                             <Checkbox
    //                                 onChange={saveMultiSelect.bind(self, question, answer)}
    //                                 disableRipple={readonlyMode}
    //                                 disableFocusRipple={readonlyMode}
    //                                 checked={answer.selected}
    //                                 value={answer.templateKey}
    //                                 // classes={{
    //                                 //     root: classes.root,
    //                                 //     checked: classes.checked,
    //                                 // }}
    //                             />
    //                         }
    //                         label={<div style={{display: "flex", alignItems: "center"}}>{<CustomTypographyStyle style={{color: getTextColor(answer.selected)}}>{answer.optionText}</CustomTypographyStyle>}</div>}
    //                     />
    //                 );
    //             })
    //             }
    //         </FormGroup>
    //     );
    // } else {

        return (
            <FormGroup style={{display: "flex", flexDirection: sideBySide === "row" ? "column" : "row"}}>
                {answers.map(answer => {
                    return (
                        <div style={{paddingLeft: "20px"}}>
                            <FormControlLabel
                                key={answer.id}
                                control={
                                    <Checkbox
                                        onChange={(e) => saveMultiSelect(question, answer, this.props)}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                e.preventDefault()
                                                saveMultiSelect(question, answer, {...this.props, target: {checked: !answer.selected}})
                                            }
                                        }}
                                        disableRipple={readonlyMode}
                                        disableFocusRipple={readonlyMode}
                                        checked={answer.selected}
                                        value={answer.templateKey}
                                        tabIndex={this.props.tabIndex}
                                        sx={{color: controlColorObj.color, "&.Mui-checked": {color: controlColorObj.selectedColor}, "&:hover": {color: answer.selected ? controlColorObj.hoverSelectedColor : controlColorObj.hoverColor}}}
                                    />
                                }
                                label={<div style={{display: "flex", alignItems: "center"}}>{<CustomTypographyStyle sx={{color: answer.selected ? textColorObj.selectedColor : textColorObj.color, "&:hover": {color: answer.selected ? textColorObj.hoverSelectedColor : textColorObj.hoverColor}}}>{answer.optionText}</CustomTypographyStyle>}</div>}
                            />
                        </div>
                    );
                })
                }
            </FormGroup>
        );
    //}
}
